import React, { useState, useEffect } from 'react';
import { ModalWrapper, ButtonGroup } from 'components/molecules';
import { PopupProps } from 'react-popup-manager/dist/src';
import { Form, Button, Input, Space, Row, Col, Select } from 'antd';
import { CheckOutlined } from '@ant-design/icons'
import { useB2cNextCode, useB2cStudentDetail } from 'hooks';
import { MailSendForm } from 'components/atoms';

export interface StudentDeleteModalProps extends PopupProps {
    lectureInfo: LectureInfoDto;
    id: number;
    group: string;
    putoff?: boolean;
}

const StudentDeleteModal = ({ 
    isOpen, 
    onClose, 
    lectureInfo, id, group, putoff=false}: StudentDeleteModalProps): React.ReactElement => {
  /* ======================================================
   * states
   * ====================================================== */    
    const [sendMail, setSendMail] = useState<string>('N');
    const [supplyPeriod, setSupplyPeriod] = useState<string>('');
    
  /* ======================================================
  * hooks
  * ====================================================== */

    const { codeList } = useB2cNextCode({lecture_gid: lectureInfo.lecture_gid, lecture_cha: lectureInfo.lecture_cha })
    const { studentInfo, studentDelete, appmDelete, studentPutoff, deleteSuccess, deleteSuccessAppm, putoffSuccess  } = useB2cStudentDetail(id, group);

   /* ======================================================
   * variables
   * ====================================================== */
  const [form] = Form.useForm();

   /* ======================================================
   * events
   * ====================================================== */

    const onSubmit = (e) => {
        if (!!studentInfo) {
            if (putoff) {                
                const into = codeList?.find((item) => item.value = e.next_group_srl);
                const history = e.history_memo + ((!!into)?' - '+into?.label:'');
                console.log(history);
                studentPutoff({
                    id: studentInfo.id,
                    history_memo: history,
                    next_group_srl: e.next_group_srl,
                })
 
            } else {
                if (group === 'seminar') {
                    appmDelete({
                        id: studentInfo.id,
                        history_memo: e.history_memo,
                    })
                } else {
                    studentDelete({
                        id: studentInfo.id,
                        history_memo: e.history_memo,
                    })
                }
            } 
        }
    };

    const onCloseClick = () => {
        onClose?.(deleteSuccess || putoffSuccess || deleteSuccessAppm);
    }

    const onConfirmClick = () => {
        form.submit();
    }

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    if (deleteSuccess || putoffSuccess || deleteSuccessAppm) {   
        onClose?.(true);
    }
    }, [deleteSuccess, putoffSuccess, deleteSuccessAppm])

    return (
    <ModalWrapper open={isOpen} onCancel={onCloseClick} width={1000} title={putoff?'공개과정 교육생 일정 연기':'공개과정 교육생 일정 취소'} closable>
        <Space direction='vertical' style={{width:'100%'}}>
            <h4 style={{marginBottom:'0px'}}>{lectureInfo.lecture_title}</h4>
            <label ><CheckOutlined /> 신청자정보</label>
            <Form
                form={form}
                name="StudentInfo"
                layout="horizontal"  
                labelCol={{ flex: '120px' }}
                onFinish={onSubmit}
                style={{width:'100%'}}
                autoComplete="off"
            >
                <Row>
                    <Col span={12}>
                    <Form.Item label={'고객사명'}>
                        <label>{studentInfo?.company}</label>                  
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item label={'신청자'}>
                        <label>{studentInfo?.name_kor}</label>                  
                    </Form.Item>   
                    </Col>            
                </Row>
                <Form.Item name={'history_memo'} label={putoff?'연기사유':'취소사유'} rules={[{ required: true, message: '' }]}>
                    <Input type="text" placeholder='' />                 
                </Form.Item>  
                {(group !== 'seminar') && (
                <Row>
                    <Col span={12}>
                    <Form.Item label={'교육담당자'}>
                        <label>{studentInfo?.edu_name}</label>                  
                    </Form.Item> 
                    </Col> 
                    <Col span={12}> 
                    <Form.Item label={'담당자연락처'}>
                        <label>{studentInfo?.edu_phone})</label>                  
                    </Form.Item>   
                    </Col>            
                </Row>
                )}               
                <Form.Item label={'기존일정'}>
                    <label>{lectureInfo.lecture_title} - 기간 : {lectureInfo.start_date} ~ {lectureInfo.end_date}</label>                    
                </Form.Item>   
                {(putoff) && (
                <Form.Item name="next_group_srl" label={'변경일정'} rules={[{ required: true, message: '' }]}>
                    <Select 
                        placeholder="변경일정 선택" 
                        options={codeList} 
                        onSelect={(value, option) => setSupplyPeriod(option.lecture_period)} />                       
                </Form.Item>   
                )} 
            </Form>
            <label ><CheckOutlined /> 메일</label> 
            {(sendMail === 'Y')?(
                <MailSendForm 
                    id={id}
                    mail_group={group}
                    mail_type={putoff?'type11':'type10'}
                    is_mail_form={false}
                    supply_period={supplyPeriod}
                    onCancel={onCloseClick}
                    onConfirm={onConfirmClick}
                />
            ) : (
                <Form
                    form={form}
                    name="StudentInfo"
                    layout="horizontal"  
                    labelCol={{ flex: '120px' }}
                    onFinish={onSubmit}
                    style={{width:'100%'}}
                    autoComplete="off"
                >
                <Form.Item name={'mail_type'} label={'유형'}>
                    <Select 
                        defaultValue={sendMail}
                        options={[{label:'발송안함', value:'N'},{label:'발송', value:'Y'}]} 
                        onSelect={(value) => setSendMail(value)}/>               
                </Form.Item>  

                    <ButtonGroup className={'buttonsWrapper'}>
                        <Button onClick={onCloseClick} style={{marginRight: "5px"}}>취소</Button>                    
                        <Button htmlType="submit"  type="primary">{'확인'}</Button>                    
                    </ButtonGroup> 
                </Form>
            )}
        </Space>        
    </ModalWrapper>  
    )    
};

export default React.memo(StudentDeleteModal);    